/*
*  The current code was generated by internal;
*  The current language is en - English - 英语;
*  Build Date 2025/12/19
*/
(function () {
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }
    callback();
  }

  onReady(function () {
    var nav = document.querySelector('.titan-navigator');
    if (!nav) return;

    var logoButton = nav.querySelector('.titan-navigator__logo');
    var arrow = nav.querySelector('.titan-navigator__arrow');
    var mobile = nav.querySelector('.titan-navigator__mobile');

    function toggleMobileDetail() {
      if (mobile) {
        mobile.classList.toggle('navigator_mobile_show');
      }
      if (arrow) {
        arrow.classList.toggle('svg-arrow-circle-bottom');
      }
    }

    if (logoButton) {
      logoButton.addEventListener('click', toggleMobileDetail);
    }

    var content = document.querySelector('#content');

    function updateSticky() {
      if (!content) return;

      var y = content.getBoundingClientRect().y;
      if (y <= 0) {
        nav.classList.add('navigator-sticky');
        nav.classList.remove('navigator-relative');
        content.style.paddingTop = nav.offsetHeight + 'px';
      } else {
        nav.classList.remove('navigator-sticky');
        nav.classList.add('navigator-relative');
        content.style.paddingTop = '0px';
      }
    }

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    updateSticky();
  });
})();
